import React from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import type { SubBot } from '../../types';
import useAuthStore from '../../store/authStore';

interface SubBotModalProps {
  isOpen: boolean;
  onClose: () => void;
  subBots: SubBot[];
  onSelectBot: (bot: SubBot) => void;
}

const SubBotModal: React.FC<SubBotModalProps> = ({
  isOpen,
  onClose,
  subBots,
  onSelectBot,
}) => {
  const { user } = useAuthStore();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={onClose} />
      
      <div className="flex min-h-screen items-center justify-center p-4">
        <div className="relative w-full max-w-2xl bg-white rounded-xl shadow-2xl">
          <div className="flex items-center justify-between p-4 border-b">
            <h3 className="text-xl font-semibold text-gray-900">Select a Tool</h3>
            <button
              onClick={onClose}
              className="p-1 hover:bg-gray-100 rounded-full transition"
            >
              <X className="h-6 w-6 text-gray-500" />
            </button>
          </div>

          <div className="p-6">
            <div className="space-y-4">
              {subBots.map((bot) => (
                <div
                  key={bot.id}
                  className="bg-gray-50 rounded-lg p-4 hover:bg-gray-100 transition-colors"
                >
                  <div className="flex items-center justify-between">
                    <div>
                      <h4 className="text-lg font-medium text-gray-900">{bot.title}</h4>
                      <p className="text-sm text-gray-500">{bot.description}</p>
                    </div>
                    <div className="flex items-center space-x-4">
                      <span className="text-sm text-gray-500">
                        {typeof bot.price === 'number' ? `$${bot.price.toFixed(2)} per use` : 'Dynamic pricing'}
                      </span>
                      {bot.id === '95b30ce0-8108-44ff-bcad-31b71c9f2fcd' ? (
                        <Link
                          to="/promptversus"
                          className="px-4 py-2 bg-gradient-to-r from-cyan-500 to-blue-600 text-white rounded-lg hover:from-cyan-600 hover:to-blue-700 transition-colors"
                        >
                          Launch
                        </Link>
                      ) : (
                        <button
                          onClick={() => {
                            if (!user || (typeof bot.price === 'number' && user.credits < bot.price)) {
                              alert('Insufficient balance. Please add funds to continue.');
                              return;
                            }
                            onSelectBot(bot);
                          }}
                          className="px-4 py-2 bg-gradient-to-r from-cyan-500 to-blue-600 text-white rounded-lg hover:from-cyan-600 hover:to-blue-700 transition-colors"
                        >
                          Launch
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubBotModal;